// extracted by mini-css-extract-plugin
export default {"button-container":"button_button-container__waSKr","button-container-small":"button_button-container-small__TsyFt","button-text":"button_button-text__7sYqf"};